import React, { Component } from 'react';

import compose from 'recompose/compose';
import { DateRange } from 'react-date-range';

//import {es} from 'date-fns/locale';
import { addDays, addMonths } from 'date-fns';
import { es, enUS, pt } from 'react-date-range/src/locale/index.js'

import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Autocomplete from '@material-ui/lab/Autocomplete';

// Shared components

import TextField from '@material-ui/core/TextField/index';
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormLabel,
    Box,
    FormHelperText,
    Chip,
    Snackbar,
    Tooltip
  } from '@material-ui/core';
import SquareIcon from '@mui/icons-material/Square';
import Alert from '@mui/material/Alert';
import moment from 'moment'
import 'moment/locale/es'

import { createMarkePeriod } from '../../../services/markedPeriod'; 
import {getMonitorsList} from '../../../services/getMonitorsList';
import { COLORS } from '../../../utils/colors';
import {getValidateMaintenance} from '../../../services/getValidateMaintenance';

// Component styles
import styles from './styles';
import { withTranslation } from 'react-i18next';
import { AlertTitle } from '@mui/material';
moment.locale('es')

const mapToShortLocale = (lng) => {
    if (!lng) return 'es'
    return (typeof lng === 'string' && lng.indexOf('-') > -1) ? lng.split('-')[0] : lng
}

const mapToDateFnsLocale = (key) => {
    switch (key) {
        case 'es': return es
        case 'pt': return pt
        case 'en':
        default:
            return enUS
    }
}

class ScheduleDataMarking extends Component {
    constructor(props) {
        const initialLocale = mapToShortLocale(props && props.i18n && props.i18n.language ? props.i18n.language : 'es')
        const listObjectives=(JSON.parse(sessionStorage.getItem("listaObjetivosOnline")))
        const user=(sessionStorage.getItem("user"))
        const nameUser=(sessionStorage.getItem("user_name"))
        super(props);
        var range={
            selection: {
                startDate: new Date(),
                endDate: new Date(),
                key: 'selection',
            }
        }
        var isBooleanDate = false
        if (props.dataMaintenance && Object.keys(props.dataMaintenance).length > 0){
            isBooleanDate = true
            range={
                selection: {
                    startDate: new Date(props.dataMaintenance.dateBegin),
                    endDate: new Date(props.dataMaintenance.dateEnd),
                    key: 'selection',
                }
            }
        } 
        moment.locale(initialLocale)
        
        //this.myCallback = this.myCallback.bind(this);
        this.state = {
            localeKey: initialLocale,
            dateFnsLocale: mapToDateFnsLocale(initialLocale),
            props: props,
            online:null,
            dateRange:range,
            booleanDate:isBooleanDate,
            listObjectives:listObjectives,
            nameUser:nameUser,
            user:user,
            newState: isBooleanDate ? {'begin': '2020-01-01 '+props.dataMaintenance.dateBegin.substring(11), 
                                       'final': '2020-01-01 '+props.dataMaintenance.dateEnd.substring(11), 
                                       'motivo': (props && props.t) ? props.t('scheduleDataMarking.defaults.motivo') : 'Marcado',
                                       'objetivo': [listObjectives.find(i => i.objetivo_id === Number(props.dataMaintenance.objetivo.objetivo_id))],
                                       'nodos': []} 
                                       : {},
            errorBegin:false,
            errorFinal:false,
            error:false,
            errors:[
                'scheduleDataMarking.errors.no_date',
                'scheduleDataMarking.errors.missing_params',
                'scheduleDataMarking.errors.bad_time_format',
                'scheduleDataMarking.errors.bad_time_range',
                'scheduleDataMarking.errors.no_objectives',
                'scheduleDataMarking.errors.end_before_start'
            ],
            loadModal:false,
            check:null,
            hourInitial: isBooleanDate ? props.dataMaintenance.dateBegin.substring(11) : '' ,
            hourFinal: isBooleanDate ? props.dataMaintenance.dateEnd.substring(11) : ''  ,
            motivo: isBooleanDate ? ((props && props.t) ? props.t('scheduleDataMarking.defaults.motivo') : 'Mantenimiento') : ''  ,
            objId: isBooleanDate ? [listObjectives.find(i => i.objetivo_id === Number(props.dataMaintenance.objetivo.objetivo_id))][0] : [],
            nodo:[],
            tipoId:"10",
            objError: [],
            objetivosAgregados: [],
            errorRepetido:false,
        }
    }

    handleRangeChange(which, payload) {
        this.setState({
            [which]: {
                ...this.state[which],
                ...payload,
            },
            booleanDate:true
        });
    
        
    }

    _onLangChanged = (lng) => {
        const key = mapToShortLocale(lng)
        moment.locale(key)
        this.setState({ localeKey: key, dateFnsLocale: mapToDateFnsLocale(key) })
    }
    
    handleFieldChange = (field, value) => {
        const {dateRange, nameUser, booleanDate, newState}=this.state
        
        if (field === 'objetivo'){
            this.setState({
                objId:value,
                Nodos: [],
                nodo: [],
                errorRepetido:false
            })
        }
        if (field === 'objetivosAgregados'){
            this.setState({
                objetivosAgregados : value,
            })
        }
        if (field === 'nodos'){
            this.setState({
                nodo: value
            })
        }
        if(field==='begin'){
            value='2020-01-01 '+String(value)
            if(String(moment(value)._f)!=="YYYY-MM-DD HH:mm:ss"){
                this.setState({
                    errorBegin:true,
                    errorRepetido:false
                })
            }else{
                value=moment(value, 'YYYY-MM-DD[T]HH:mm:ss')
                this.setState({
                    errorBegin:false,
                    hourInitial:value,
                    Nodos: [],
                    nodo: [],
                    errorRepetido:false
                })
            }
            
        }
        if(field==='final'){
            value='2020-01-01 '+String(value)
            if(String(moment(value)._f)!=="YYYY-MM-DD HH:mm:ss"){
                this.setState({
                    errorFinal:true,
                    errorRepetido:false
                })
            }else{
                this.setState({
                    errorFinal:false,
                    hourFinal:value,
                    Nodos: [],
                    nodo: [],
                    errorRepetido:false
                })
            }
            
        }else{
            this.setState({
                errorFinal:false,
                errorRepetido:false
            })
        }
        newState[field] = value;

        if(Object.keys(newState).length===5){
            this.setState({
                newState:newState,
                errorRepetido:false
            })
        }
    };

    componentDidUpdate(prevProps, prevState){
        const {hourFinal, hourInitial, objId, dateRange}=this.state
        if (hourInitial && hourFinal && (objId && Object.keys(objId).length !== 0) ){
            if (hourInitial !== prevState.hourInitial ){
                this.getMonitorsFromApi()
            }
            if (hourFinal !== prevState.hourFinal){
                this.getMonitorsFromApi()
            }
            if (prevState.objId !== objId){
                this.getMonitorsFromApi()
            }
            if (prevState.dateRange !== dateRange){
                this.getMonitorsFromApi()
            }
        }
    }

    componentDidMount(){
        const {hourFinal, hourInitial, objId, dateRange}=this.state
        if (hourInitial && hourFinal && (objId && Object.keys(objId).length !== 0) ){
            this.getMonitorsFromApi()
        }
        if (this.props && this.props.i18n && this.props.i18n.on) {
            this.props.i18n.on('languageChanged', this._onLangChanged)
        }
    }

    componentWillUnmount() {
        if (this.props && this.props.i18n && this.props.i18n.off) {
            this.props.i18n.off('languageChanged', this._onLangChanged)
        }
    }

    getMonitorsFromApi() {
        const {objId, dateRange, newState}=this.state
        let token = sessionStorage.getItem('key')
        var begin=(moment(dateRange.selection.startDate).format("YYYY-MM-DD")+' '+moment(newState['begin']).format("HH:mm:ss"))
        var final=(moment(dateRange.selection.endDate).format("YYYY-MM-DD")+' '+moment(newState['final']).format("HH:mm:ss"))
        var getData = getMonitorsList(objId['objetivo_id'], begin, final, token)           
        getData.then( data =>  { 
            var indexRemove = 0
            Object.values(data).map((item, index) => { 
                if (item.id_nodo == 0){
                    indexRemove = index
                }
            })
            newState['nodos'] = data
            let remove = data.splice(indexRemove, 1)
            this.setState({
                Nodos:data,
                nodo:data,
                newState: newState,
            })
        })     

    }

    /*handleSaved = async (value) => {
        const {dateRange, nameUser, booleanDate,newState, errorBegin, errorFinal, listObjectives, user, nodo, objId, tipoId, objError}=this.state
        const {motivo, objetivos, nodos, marcado}=newState
        
        if(booleanDate===false){
            this.setState({
                error:true,
                errorIndex:0
            })
        }else if(Object.keys(newState).length!==5){
            this.setState({
                error:true,
                errorIndex:1
            })
        }else{
            var newObjetivo = objId.objetivo_id
            var newNodos = (nodo.map(ele=>ele.id_nodo))
            var begin=(moment(dateRange.selection.startDate).format("YYYY-MM-DD")+' '+moment(newState['begin']).format("HH:mm:ss"))
            var final=(moment(dateRange.selection.endDate).format("YYYY-MM-DD")+' '+moment(newState['final']).format("HH:mm:ss"))
            
            if(errorBegin===true || errorFinal===true){
                this.setState({
                    error:true,
                    errorIndex:2
                })
            }else if(moment(newState['begin']).unix()==moment(newState['final']).unix()){
                this.setState({
                    error:true,
                    errorIndex:3
                })
            }else if(newState['objetivo'].length===0){
                this.setState({
                    error:true,
                    errorIndex:4
                })
            }else if(begin > final){
                this.setState({
                    error:true,
                    errorIndex: 5
                })
            }else{
                let admin = sessionStorage.getItem('admin')
                let admin_id = sessionStorage.getItem('admin_id')
                let timezone = sessionStorage.getItem('tz')
                let token = sessionStorage.getItem('key')
                //const {comment, titulo, objetivos}=newState
                //var begin=(moment(dateRange.selection.startDate).format("YYYY-MM-DD")+' '+moment(newState['begin']).format("HH:mm:ss"))
                //var final=(moment(dateRange.selection.endDate).format("YYYY-MM-DD")+' '+moment(newState['final']).format("HH:mm:ss"))

                getValidateMaintenance(user, token, begin, final, newObjetivo, newNodos).then(data=>{
                    if (data.length > 0){ 
                        const listaNodosConflictivos = data.flatMap(item => item.nodos_id);
                        this.setState({
                            loadModal: true,
                            check: false,
                            objError: data,
                            errorIndex: 6,
                            error:true,
                            nodosError: listaNodosConflictivos
                        });
                    } else {
                        /* llamo para hacer el insert si responde sale guardar si no que hubo error*/
                        /*createMarkePeriod({
                            objetivo_id: newObjetivo,
                            nodos_id: newNodos,
                            fecha_inicio: begin,
                            fecha_termino: final,
                            motivo: motivo,
                            autorizacion: admin,
                            usuario: admin_id,
                            id_tipo_marcado: parseInt(tipoId),
                            tz:timezone
                        }).then(response=>{
                            if(response.status !== 200){
                                this.setState({
                                    loadModal: true,
                                    check: false
                                });
                            }else{
                                this.setState({
                                    loadModal: true,
                                    check: true
                                }); 
                        }})

                    }

                })
            }
        }
    }*/

    handleSaved = async () => {
        const { 
            dateRange, booleanDate, errorBegin, errorFinal, 
            user, tipoId, newState, objetivosAgregados 
        } = this.state;
        
        const { motivo } = newState;
        // 1. Validar que al menos exista un registro en la lista antes de guardar
        if (!objetivosAgregados || objetivosAgregados.length === 0) {
            return this.setState({ 
                error: true, 
                errorIndex: 4 // O el índice que definas para "Lista vacía"
            });
        }
    
        // 2. Validaciones iniciales de fechas generales
        if (booleanDate === false) return this.setState({ error: true, errorIndex: 0 });
        if (errorBegin === true || errorFinal === true) return this.setState({ error: true, errorIndex: 2 });
    
        const beginUnix = moment(newState['begin']).unix();
        const finalUnix = moment(newState['final']).unix();
        if (beginUnix === finalUnix) return this.setState({ error: true, errorIndex: 3 });
    
        const begin = `${moment(dateRange.selection.startDate).format("YYYY-MM-DD")} ${moment(newState['begin']).format("HH:mm:ss")}`;
        const final = `${moment(dateRange.selection.endDate).format("YYYY-MM-DD")} ${moment(newState['final']).format("HH:mm:ss")}`;
    
        if (begin > final) return this.setState({ error: true, errorIndex: 5 });
    
        // Carga de credenciales de sesión
        const admin = sessionStorage.getItem('admin');
        const admin_id = sessionStorage.getItem('admin_id');
        const timezone = sessionStorage.getItem('tz');
        const token = sessionStorage.getItem('key');
    
        // Inicializamos acumuladores de errores y lista de payloads limpios
        let acumuladoObjError = [];
        let acumuladoNodosError = [];
        const registrosListosParaGuardar = [];
    
        // ==========================================
        // FASE 1: VALIDAR TODOS LOS REGISTROS DE LA LISTA
        // ==========================================
        for (const item of objetivosAgregados) {
            const currentObjetivoId = item.objetivo.objetivo_id;
            const currentNodosIds = item.nodos.map(ele => ele.id_nodo);
    
            try {
                // Petición de validación por cada elemento de la lista
                const data = await getValidateMaintenance(user, token, begin, final, currentObjetivoId, currentNodosIds);
    
                if (data && data.length > 0) {
                    // Si este objetivo/nodo tiene conflictos, acumulamos los errores
                    acumuladoObjError = [...acumuladoObjError, ...data];
                    const listaNodosConflictivos = data.flatMap(i => i.nodos_id);
                    acumuladoNodosError = [...acumuladoNodosError, ...listaNodosConflictivos];
                } else {
                    // Si está limpio, preparamos su estructura para la Fase 2
                    registrosListosParaGuardar.push({
                        objetivo_id: currentObjetivoId,
                        nodos_id: currentNodosIds,
                        fecha_inicio: begin,
                        fecha_termino: final,
                        motivo: motivo,
                        autorizacion: admin,
                        usuario: admin_id,
                        id_tipo_marcado: parseInt(tipoId),
                        tz: timezone
                    });
                }
            } catch (error) {
                return this.setState({ loadModal: true, check: false, error: true });
            }
        }
    
        // SI HUBO ERRORES: Frenamos el proceso aquí y actualizamos el estado para que el render los dibuje
        if (acumuladoObjError.length > 0) {
            return this.setState({
                loadModal: true,
                check: false,
                objError: acumuladoObjError,
                nodosError: acumuladoNodosError,
                errorIndex: 6,
                error: true
            });
        }
    
        // ==========================================
        // FASE 2: GUARDAR SI TODOS ESTÁN LIMPIOS
        // ==========================================
        try {
            for (const datosRegistro of registrosListosParaGuardar) {
                const response = await createMarkePeriod(datosRegistro);
                
                if (response.status !== 200) {
                    return this.setState({ loadModal: true, check: false });
                }
            }
    
            // Éxito rotundo: Limpiamos errores anteriores y vaciamos la lista guardada
            this.setState({
                loadModal: true,
                check: true,
                error: false,
                objError: [],
                nodosError: [],
                objetivosAgregados: [] // Opcional: vacía la lista en pantalla tras guardar con éxito
            });
    
        } catch (error) {
            this.setState({ loadModal: true, check: false, error: true });
        }
    }

    handleClose = event => {
        //const newStep = event.currentTarget.id
        if (this.state.check === true) {
            this.props.onInfo(0)
        }
        
        this.setState({
            loadModal: false,
        })
    };

    handleChangeMarcado = (event) => {
        this.setState({
            tipoId: event.target.value,
        })
    };

    isValidHour = (value) => {
        // 1. Si es null o undefined, no es válido
        if (!value) return false;
    
        // 2. Si es un objeto Date, verificamos que sea una fecha real/válida
        if (value instanceof Date) {
            return !isNaN(value.getTime());
        }
    
        // 3. Si es un string (u otro tipo), limpiamos espacios y vemos si tiene texto
        return String(value).trim() !== '';
    }
    

    render() {
        const { classes, className, alertobjectives, t, ...rest } = this.props;
        const {dateRange, booleanDate,nameUser, listObjectives, errorBegin, errorFinal, errorIndex, errors,
                 error, loadModal, check, hourInitial, hourFinal, motivo, objId, nodo, Nodos, tipoId, objError, nodosError, objetivosAgregados,
                 errorRepetido}=this.state
        const selectorDeshabilitado = !this.isValidHour(hourInitial) || !this.isValidHour(hourFinal);
        return (
            <Portlet
            >
                <PortletHeader>
                <PortletLabel
                    subtitle={t ? t('scheduleDataMarking.subtitle') : 'Ingrese Evento Atentus'}
                    title={t ? t('scheduleDataMarking.title') : 'Agenda'}
                />
                </PortletHeader>
                <PortletContent noPadding>
                    <form
                        autoComplete="off"
                        noValidate
                    >
                        <Grid
                            container
                            style={{ padding: "20px 30px" }}
                        >
                            {/* Campo Nombre */}
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                xl={12}
                                style={{ textAlign: "left" }}
                            >
                                <TextField
                                    //helperText="Nombre"
                                    label={t ? t('scheduleDataMarking.label.name') : 'Nombre'}
                                    margin="dense"
                                    onChange={event =>
                                        this.handleFieldChange('name', event.target.value)
                                    }
                                    required
                                    value={nameUser[0].toUpperCase() + nameUser.substring(1)}
                                    disabled id="standard-disabled"
                                    //variant="outlined"
                                />
                            </Grid>

                            {/* Estructura de 2 columnas (50% / 50%) */}
                            <Grid item xs={12}>
                                <Grid container spacing={3}>

                                    {/* COLUMNA 1 (IZQUIERDA): DateRange centrado */}
                                    <Grid
                                        item
                                        xs={12}
                                        md={6}
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <Typography style={{ marginBottom: '16px' }}>
                                            {t ? t('scheduleDataMarking.define_range') : 'Definir Rango de Tiempo'}
                                        </Typography>
                                        <DateRange
                                            //maxDate={addDays(new Date(), 0)}
                                            minDate={addMonths(new Date(), -3)}
                                            locale={this.state.dateFnsLocale}
                                            key={'dr-' + this.state.localeKey}
                                            onChange={this.handleRangeChange.bind(this, 'dateRange')}
                                            moveRangeOnFirstSelection={false}
                                            ranges={[this.state.dateRange.selection]}
                                            className={'PreviewArea'}
                                        />
                                    </Grid>

                                    {/* COLUMNA 2 (DERECHA): Visible siempre pero deshabilitada si !booleanDate */}
                                    <Grid
                                        item
                                        xs={12}
                                        md={6}
                                        style={{
                                            opacity: booleanDate ? 1 : 0.5,
                                            transition: 'opacity 0.3s ease'
                                        }}
                                    >
                                        <Grid
                                            container
                                            spacing={1}
                                            style={{ textAlign: "left" }}
                                        >
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                xl={12}
                                            >
                                                <FormControl disabled={!booleanDate}>
                                                    <FormLabel id="demo-controlled-radio-buttons-group">{t ? t('scheduleDataMarking.formlabel.type') : 'Tipo de Marcado'}</FormLabel>
                                                    <RadioGroup
                                                        //row
                                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                                        name="controlled-radio-buttons-group"
                                                        value={tipoId}
                                                        onChange={this.handleChangeMarcado}
                                                    >
                                                        <FormControlLabel value="7" control={<Radio disabled={!booleanDate} />} label={<React.Fragment><SquareIcon style={{ verticalAlign: 'middle', display: 'inline-flex', color: COLORS.NO_MONITOREO }} fontSize="small"></SquareIcon> {t ? t('scheduleDataMarking.radio.data_mark') : 'Marcado de Datos'}</React.Fragment>} />
                                                        <FormControlLabel value="10" control={<Radio disabled={!booleanDate} />} label={<React.Fragment><SquareIcon style={{ verticalAlign: 'middle', display: 'inline-flex', color: COLORS.MARCADO_ATENTUS }} fontSize="small"></SquareIcon> {t ? t('scheduleDataMarking.radio.atentus_event') : 'Evento Atentus'}</React.Fragment>} />
                                                    </RadioGroup>
                                                </FormControl>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                xl={12}
                                            >
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    xl={12}
                                                >
                                                    <TextField
                                                        disabled={!booleanDate}
                                                        label={t ? t('scheduleDataMarking.label.hour_start') : 'Hora Inicio'}
                                                        margin="dense"
                                                        required
                                                        onChange={event =>
                                                            this.handleFieldChange('begin', event.target.value)
                                                        }
                                                        placeholder="00:00:00"
                                                        defaultValue={hourInitial}
                                                        type="time"
                                                        inputProps={{ step: 1 }}
                                                        inputRef={el => this.startTimeInputRef = el}
                                                        onClick={() => {
                                                            if (booleanDate && this.startTimeInputRef && typeof this.startTimeInputRef.showPicker === 'function') {
                                                                this.startTimeInputRef.showPicker();
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                                {errorBegin ?
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={12}
                                                        xl={12}
                                                    >
                                                        <Typography variant="caption" color="primary">{t ? t('scheduleDataMarking.errors.bad_date_format') : 'Error en formato de fecha'}</Typography>
                                                    </Grid>
                                                    : null
                                                }
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                xl={12}
                                            >
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    xl={12}
                                                >
                                                    <TextField
                                                        disabled={!booleanDate}
                                                        label={t ? t('scheduleDataMarking.label.hour_end') : 'Hora Termino'}
                                                        margin="dense"
                                                        required
                                                        onChange={event =>
                                                            this.handleFieldChange('final', event.target.value)
                                                        }
                                                        placeholder="23:59:00"
                                                        defaultValue={hourFinal}
                                                        type="time"
                                                        inputProps={{ step: 1 }}
                                                        inputRef={el => this.endTimeInputRef = el}
                                                        onClick={() => {
                                                            if (booleanDate && this.endTimeInputRef && typeof this.endTimeInputRef.showPicker === 'function') {
                                                                this.endTimeInputRef.showPicker();
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                                {errorFinal ?
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={12}
                                                        xl={12}
                                                    >
                                                        <Typography variant="caption" color="primary">{t ? t('scheduleDataMarking.errors.bad_date_format') : 'Error en formato de fecha'}</Typography>
                                                    </Grid>
                                                    : null}
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                xl={12}
                                                style={{ marginBottom: '20px' }}
                                            >
                                                <TextField
                                                    disabled={!booleanDate}
                                                    label={t ? t('scheduleDataMarking.label.motivo') : 'Motivo'}
                                                    margin="dense"
                                                    required
                                                    onChange={event =>
                                                        this.handleFieldChange('motivo', event.target.value)
                                                    }
                                                    defaultValue={motivo}
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                xl={12}
                                                style={{ marginBottom: '20px' }}
                                            >
                                                <FormControl size='small' variant='outlined' fullWidth disabled={!booleanDate || selectorDeshabilitado}>
                                                    <InputLabel id='objetivo-update-label'>{t ? t('scheduleDataMarking.select.objective') : 'Seleccione Objetivo'}</InputLabel>
                                                    <Select
                                                        labelId='objetivo-update-label'
                                                        disabled={!booleanDate || selectorDeshabilitado}
                                                        value={objId || ''}
                                                        label={t ? t('scheduleDataMarking.select.objective_label') : 'Objetivo'}
                                                        onChange={event => {
                                                            this.handleFieldChange('objetivo', event.target.value);
                                                            this.handleFieldChange('nodos', []);
                                                        }}
                                                    >
                                                        {Object.keys(listObjectives).map((key) => {
                                                            const objetivo = listObjectives[key];
                                                            return (
                                                                <MenuItem key={objetivo.objetivo_id} value={objetivo}>
                                                                    {objetivo.nombre}
                                                                </MenuItem>
                                                            );
                                                        })}
                                                    </Select>
                                                    {selectorDeshabilitado && booleanDate && (
                                                        <FormHelperText errorStyle={{ color: '#ff9800' }}>
                                                            💡 {t ? t('scheduleDataMarking.help.select_hours_first') : 'Debe ingresar la Hora de Inicio y Término para habilitar este selector.'}
                                                        </FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                xl={12}
                                            >
                                                {(Nodos && Nodos.length > 0) ? <div><Autocomplete
                                                    disabled={!booleanDate}
                                                    multiple
                                                    defaultValue={nodo}
                                                    value={nodo}
                                                    options={Nodos}
                                                    getOptionLabel={option => option.id_nodo + " - " + option.nodo}
                                                    onChange={(e, val) => this.handleFieldChange('nodos', val)}
                                                    renderTags={(tagValue, getTagProps) =>
                                                        tagValue.map((option, index) => {
                                                            const idsProhibidos = nodosError || [];
                                                            const hasError = idsProhibidos.includes(option.id_nodo);

                                                            const chip = (
                                                                <Chip
                                                                    label={option.nodo}
                                                                    {...getTagProps({ index })}
                                                                    style={{
                                                                        backgroundColor: hasError ? '#ed9987' : '#b1d1fa',
                                                                        color: 'white',
                                                                        fontWeight: 'bold',
                                                                        textShadow: '1px 1px 2px rgba(0,0,0,0.8)',
                                                                        border: hasError ? '1px solid #b71c1c' : '1px solid #2196f3',
                                                                        boxShadow: hasError ? '0px 0px 5px rgba(244, 67, 54, 0.5)' : 'none'
                                                                    }}
                                                                />
                                                            );
                                                            return (
                                                                <React.Fragment key={option.id_nodo}>
                                                                    {chip}
                                                                </React.Fragment>
                                                            );
                                                        })
                                                    }
                                                    renderInput={params => (
                                                        <TextField
                                                            {...params}
                                                            variant="standard"
                                                            label={t ? t('scheduleDataMarking.autocomplete.label') : 'Selecciona Isp(s)'}
                                                            placeholder={t ? t('scheduleDataMarking.autocomplete.placeholder') : 'Isp(s)'}
                                                            fullWidth
                                                            helperText={
                                                                (nodosError && nodosError.length > 0)
                                                                    ? t ? t('scheduleDataMarking.autocomplete.error') : 'Algunos isp(s) seleccionados tienen conflictos de horario (en rojo).'
                                                                    : ""
                                                            }
                                                            error={nodosError && nodosError.length > 0}
                                                        />
                                                    )}
                                                />
                                                </div>
                                                    : (objId && Object.keys(objId).length > 0) ?
                                                        <Box p={2} style={{ border: '1px dashed #ffa726', backgroundColor: '#fff9c4', borderRadius: '4px', marginTop: '10px' }}>
                                                            <Typography variant="body2" style={{ color: '#b78103', fontWeight: 'medium', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                ⚠️ {t ? t('scheduleDataMarking.errors.no_nodes') : 'Este objetivo no cuenta con ISPs asociados.'}
                                                            </Typography>
                                                        </Box>
                                                        : null
                                                }
                                            </Grid>

                                            {/* Historial / Acumulado */}
                                            {objetivosAgregados.length > 0 && (
                                                <Grid item xs={12} style={{ marginTop: '15px', marginBottom: '15px' }}>
                                                    <Typography variant="caption" style={{ fontWeight: 'bold', textTransform: 'uppercase', color: '#777' }}>
                                                        {t ? t('scheduleDataMarking.list_objectives_nodes') : 'Objetivos y Nodos listos para agendar:'}
                                                    </Typography>
                                                    <Box mt={1} display="flex" flexDirection="column" gap={1.5}>
                                                        {objetivosAgregados.map((item, index) => {
                                                            const errorDetalle = objError && objError.find(err => Number(err.objetivo_id) === Number(item.objetivo.objetivo_id));

                                                            return (
                                                                <Box
                                                                    key={item.objetivo.objetivo_id}
                                                                    p={1.5}
                                                                    style={{
                                                                        backgroundColor: errorDetalle ? '#fff5f5' : '#fff',
                                                                        border: errorDetalle ? '1px solid #ef5350' : '1px solid #e0e0e0',
                                                                        borderRadius: '4px'
                                                                    }}
                                                                >
                                                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                                                        <Box>
                                                                            <Typography variant="body2" style={{ fontWeight: 'bold', color: errorDetalle ? '#c62828' : 'inherit' }}>
                                                                                {item.objetivo.nombre} {errorDetalle ? '⚠️' : ''}
                                                                            </Typography>
                                                                            <Typography variant="caption" color={errorDetalle ? 'error' : 'textSecondary'}>
                                                                                {t ? t('scheduleDataMarking.autocomplete.placeholder') : 'Isp(s) '}: {
                                                                                    item.nodos.map(n => {
                                                                                        const nodoTieneError = nodosError && nodosError.includes(n.id_nodo);
                                                                                        return nodoTieneError ? `${n.nodo} (❌)` : n.nodo;
                                                                                    }).join(', ')
                                                                                }
                                                                            </Typography>
                                                                        </Box>
                                                                        <Button
                                                                            disabled={!booleanDate}
                                                                            size="small"
                                                                            color="error"
                                                                            onClick={() => {
                                                                                const filtrados = objetivosAgregados.filter((_, i) => i !== index);
                                                                                this.handleFieldChange('objetivosAgregados', filtrados);

                                                                                if (objError) {
                                                                                    const erroresLimpios = objError.filter(err => Number(err.objetivo_id) !== Number(item.objetivo.objetivo_id));
                                                                                    this.setState({ objError: erroresLimpios });
                                                                                }
                                                                            }}
                                                                        >
                                                                            {t ? t('scheduleDataMarking.button.remove_objective_list') : 'Quitar'}
                                                                        </Button>
                                                                    </Box>

                                                                    {errorDetalle && (
                                                                        <Box mt={1} p={1} style={{ backgroundColor: '#fee2e2', borderRadius: '4px', borderLeft: '4px solid #b71c1c' }}>
                                                                            {(() => {
                                                                                const opciones = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false };
                                                                                const inicio = new Date(errorDetalle.fecha_inicio).toLocaleString(undefined, opciones);
                                                                                const termino = new Date(errorDetalle.fecha_termino).toLocaleString(undefined, opciones);
                                                                                const errorMessage = 'scheduleDataMarking.select.error_type_' + errorDetalle.id_tipo_marcado;

                                                                                return (
                                                                                    <Typography variant="caption" display="block" style={{ color: '#b71c1c', fontWeight: '500', lineHeight: '1.4' }}>
                                                                                        ❌ {t ? t(errorMessage) : 'Conflicto detectado con mantenimiento agendado: '}<br />
                                                                                        • {t ? t('scheduleDataMarking.select.error_from') : 'Desde: '} {inicio} <br />
                                                                                        • {t ? t('scheduleDataMarking.select.error_to') : 'Hasta: '} {termino}
                                                                                    </Typography>
                                                                                );
                                                                            })()}
                                                                        </Box>
                                                                    )}
                                                                </Box>
                                                            );
                                                        })}
                                                    </Box>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid>

                                </Grid>
                            </Grid>

                            {/* Notificación Snackbar */}
                            <Snackbar
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}
                                open={loadModal}
                                autoHideDuration={5000}
                                onClose={this.handleClose}
                            >
                                {check ? (
                                    <Alert
                                        onClose={this.handleClose}
                                        severity="success"
                                        variant="filled"
                                        sx={{ width: '100%' }}
                                    >
                                        <AlertTitle style={{ color: 'white' }}>{t ? t('scheduleDataMarking.modal.success-title') : 'Mantenimiento ingresado con exito.'}</AlertTitle>
                                        {t ? t('scheduleDataMarking.modal.success') : 'Mantenimiento ingresado con exito.'}
                                    </Alert>
                                ) : (
                                    <Alert
                                        onClose={this.handleClose}
                                        severity="error"
                                        variant="filled"
                                        sx={{ width: '100%' }}
                                    >
                                        {t ? t('scheduleDataMarking.modal.error') : 'Ha ocurrido un error, intente nuevamente'}
                                    </Alert>
                                )}
                            </Snackbar>
                        </Grid>
                    </form>
                </PortletContent>
                <PortletFooter align="right">
                    {/* CONTENEDOR DE ERRORES (Para que no rompan la alineación de los botones) */}
                    <Box display="flex" flexDirection="column" alignItems="flex-end" width="100%" mb={1}>
                        {errorRepetido && (
                            <Typography color="error" variant="caption" display="block" mb={0.5}>
                                {t ? t('scheduleDataMarking.errors.duplicate') : 'Este registro ya ha sido agregado a la lista.'}
                            </Typography>
                        )}
                        {error && (
                            <Typography variant="caption" color="error" display="block">
                                {t ? t(errors[errorIndex]) : ''}
                            </Typography>
                        )}
                    </Box>

                    {/* CONTENEDOR HORIZONTAL PARA LOS BOTONES */}
                    <Box display="flex" justifyContent="flex-end" alignItems="center" gap={4} mt={1}>
                        {/* BOTÓN 1: AGREGAR A LA LISTA */}
                        <Tooltip 
                            title={t ? t('scheduleDataMarking.tooltip.add_disabled') : 'Debe seleccionar al menos un ISP antes de agregar a la lista.'}
                            disableHoverListener={Boolean(nodo && nodo.length > 0)}
                            disableTouchListener={Boolean(nodo && nodo.length > 0)}
                        >
                            <span>
                                <Button 
                                    variant="outlined" 
                                    color="primary"
                                    size="small"
                                    disabled={!nodo || nodo.length === 0}
                                    onClick={() => {
                                        // 1. Validar si el objetivo ya existe con exactamente los mismos nodos
                                        const esRepetido = objetivosAgregados.some(item => {
                                            const mismoObjetivo = item.objetivo === objId;
                                            const mismosNodos = JSON.stringify(item.nodos) === JSON.stringify(nodo);
                                            return mismoObjetivo && mismosNodos;
                                        });

                                        // 2. Si está repetido, frenamos la acción
                                        if (esRepetido) {
                                            this.setState({ errorRepetido: true });
                                            return; 
                                        }

                                        this.setState({ errorRepetido: false });
                                        
                                        // Agregamos al listado acumulativo
                                        const nuevaLista = [...objetivosAgregados, { objetivo: objId, nodos: nodo }];
                                        this.handleFieldChange('objetivosAgregados', nuevaLista);
                                        
                                        // Limpiamos el selector superior
                                        this.handleFieldChange('objetivo', null);
                                        this.handleFieldChange('nodos', []);
                                    }}
                                >
                                    + {t ? t('scheduleDataMarking.button.add_objective_list') : 'Agregar a la Lista'}
                                </Button>
                            </span>
                        </Tooltip>
                        {/* BOTÓN 2: GUARDAR MANTENIMIENTO */}
                        <Tooltip 
                            title={t ? t('scheduleDataMarking.tooltip.save') : 'Debe haber al menos un objetivo en la lista para habilitar este botón'}
                            disableHoverListener={objetivosAgregados.length > 0} 
                            disableTouchListener={objetivosAgregados.length > 0}
                        >
                            <span style={{ marginLeft: '16px' }}>
                                <Button
                                    onClick={this.handleSaved}
                                    color="primary"
                                    variant="contained"
                                    size="small"
                                    disabled={objetivosAgregados.length === 0}
                                >
                                    {t ? t('scheduleDataMarking.button.save') : 'Guardar Mantenimiento'}
                                </Button>
                            </span>
                        </Tooltip>
                    </Box>
                </PortletFooter>
            </Portlet>
            
        );
    }
}


export default compose(withWidth(), withStyles(styles), withTranslation())(ScheduleDataMarking);